import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AreaData } from 'src/app/model/area.model';
import { ApiService } from 'src/app/services/api.service';
import { Customer } from './../../model/customer.model';
import { Role } from 'src/app/model/role';

@Component({
  selector: 'customer-modal',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
})
export class CustomerDialog implements OnInit {
 
  constructor(
    public dialogRef: MatDialogRef<CustomerDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Customer,
    private apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  areas: AreaData[];
  customers: Customer[];
  enableButton: boolean = false;
  lat: number = 5.1521;
  lng: number = 46.1996;
   isSuperAdmin: boolean = false;
  ngOnInit() {
  this.apiService.getAreaDetails().subscribe((data) => {
    this.areas = data.areas;
  });
  this.apiService.getCustomers().subscribe((data) => {
    this.customers = data.customers;
  });
   const loggedInUser = window.localStorage.getItem('loggedInUser');
     this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data) => {
            
             let roles = data.roles.map((role : Role)=>role.roleName);
             if(roles.includes("superadmin")){
              this.isSuperAdmin =true;  
             }
      
                   
          });

  }
  updateCustomer(customerData: Customer): void {
    this.apiService.updateCustomer(customerData).subscribe((data) => {
      if (data.isSuccess === true) {
        this.dialogRef.close();
        this._snackBar.open('Customer data updated successfully', 'Close', {
          duration: 3000,
        });
      } else {
        this._snackBar.open('Error occured while updating details', 'Close', {
          duration: 3000,
        });
      }
    });
  }
  addCustomer(customerData: Customer): void {
    // const valueExsist = this.customers.filter(function (item) {
    //     return item.customerId === customerData.customerId;
    // });
    // if(valueExsist.length != 0 ){
    //   this._snackBar.open('Customer data added successfully', 'Close', {
    //     duration: 3000,
    //   });
    //   return;
    // }
    this.apiService.addCustomer(customerData).subscribe((data) => {
      if (data.customerId > 0) {
        this.dialogRef.close();
        this._snackBar.open('Customer with Id: '+data.customerId +' created successfully', 'Close');
      } else {
        this._snackBar.open('Error occured while updating details', 'Close', {
          duration: 3000,
        });
      }
    });
  }
  validateAdd(){
    if (this.data.customerId >0){
      return true;
    }else{
      return false;
    }

  }
}
